import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';
import { getJobFieldSettings, IJobFieldSettings } from 'wisestep-api';

import { getDefaultJobFieldSettings } from '../../../../features/jobSettings/customizeJobFields/Helper';
import { IJobCategory } from '../../helper';

interface ListingSettings {
  jobFieldSettings: IJobFieldSettings;
  selectedCategory: IJobCategory[] | undefined;
}

const useListingSettings = (): ListingSettings => {
  const [jobFieldSettings, setJobFieldSettings] = useState<IJobFieldSettings>(
    getDefaultJobFieldSettings()
  );
  const [selectedCategory, setSelectedCategory] = useState<IJobCategory[]>();

  useEffect(() => {
    getJobFieldSettings().then((response) => {
      if (response.data.id) setJobFieldSettings(response.data);
      if (!isEmpty(response.data) && response.data.id) {
        setJobFieldSettings(response.data);
        const categories = response.data.jobCategory;
        const selectedFields = categories.selectedFields?.map((category) => JSON.parse(category));
        setSelectedCategory(selectedFields);
      }
    });
  }, []);

  return { jobFieldSettings, selectedCategory };
};

export default useListingSettings;
